import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const stickerDefaultVariants = {
  "size": "md",
  "variant": "circle"
}
const stickerCompoundVariants = [
  {
    "variant": "rounded",
    "size": "xs",
    "css": {
      "root": {
        "borderRadius": "4"
      }
    }
  },
  {
    "variant": "rounded",
    "size": "sm",
    "css": {
      "root": {
        "borderRadius": "4"
      }
    }
  },
  {
    "variant": "rounded",
    "size": "md",
    "css": {
      "root": {
        "borderRadius": "6"
      }
    }
  },
  {
    "variant": "rounded",
    "size": "lg",
    "css": {
      "root": {
        "borderRadius": "8"
      }
    }
  },
  {
    "variant": "rounded",
    "size": "xl",
    "css": {
      "root": {
        "borderRadius": "10"
      }
    }
  }
]

const stickerSlotNames = [
  [
    "root",
    "sticker__root"
  ],
  [
    "icon",
    "sticker__icon"
  ]
]
const stickerSlotFns = /* @__PURE__ */ stickerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, stickerDefaultVariants, getSlotCompoundVariant(stickerCompoundVariants, slotName))])

const stickerFn = memo((props = {}) => {
  return Object.fromEntries(stickerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const stickerVariantKeys = [
  "size",
  "variant"
]
const getVariantProps = (variants) => ({ ...stickerDefaultVariants, ...compact(variants) })

export const sticker = /* @__PURE__ */ Object.assign(stickerFn, {
  __recipe__: false,
  __name__: 'sticker',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: stickerVariantKeys,
  variantMap: {
  "size": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
  ],
  "variant": [
    "circle",
    "rounded"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, stickerVariantKeys)
  },
  getVariantProps
})